import * as React from 'react'

const Email = ({ className = 'svg-white' }: { className?: string }) => (
  <svg
    className={'icon ' + className}
    width='13'
    height='10'
    viewBox='0 0 13 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M1 1H12.5M1 1V9H12.5V1M1 1L7 5.5L12.5 1' stroke='white' strokeOpacity='0.5' />
  </svg>
)

export default Email



// WEBPACK FOOTER //
// ./src/components/icons/auth/Email.tsx